import { render, staticRenderFns } from "./issueCard.vue?vue&type=template&id=bb58bb98&scoped=true&"
import script from "./issueCard.vue?vue&type=script&lang=js&"
export * from "./issueCard.vue?vue&type=script&lang=js&"
import style0 from "./issueCard.vue?vue&type=style&index=0&id=bb58bb98&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb58bb98",
  null
  
)

export default component.exports